import { render } from "./ExternalLinkIcon.vue?vue&type=template&id=ab880b18"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__